import ButtonMedium1 from "components/elements/ButtonMedium1"
import ButtonMedium3 from "components/elements/ButtonMedium3"
import Headline4 from "components/elements/Headline4"
import ContentExtraSmall from "components/elements/ContentExtraSmall"
import { Link } from "react-router-dom"
import {Paper} from "@mui/material"
import './CookiePopUp.css'
import { translate } from "utils/Translate"

const CookiePopUp = (props) => {
    const callbackFunction = props.callback
    const isInline = !!props.inline
    const placementStyle = isInline ? {
        position: 'relative',
        left: 'auto',
        top: 'auto',
        transform: 'none',
        zIndex: 1,
    } : {}

    function createCookie() {
        document.cookie = "cookieConsent"
        callbackFunction(true)
    }
    
    return (
        <div className='cookie-popup-backdrop'>
            <Paper square={!isInline}
                style={{
                    width: isInline ? 'min(var(--auth-cookie-width, 375px), calc(100vw - 48px))' : 375,
                    height: isInline ? 'auto' : 375,
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: isInline ? 'flex-start' : 'space-between',
                    zIndex: 2,
                    padding: 0,
                    overflow: isInline ? 'hidden' : undefined,
                    borderRadius: isInline ? 20 : undefined,
                    border: isInline ? '1px solid rgba(38, 56, 74, 0.1)' : undefined,
                    boxShadow: isInline ? '0 20px 55px rgba(20, 36, 56, 0.16)' : undefined,
                    filter: isInline ? 'none' : 'drop-shadow(0px 0px 100px rgba(34, 34, 34, 0.15))',
                    ...placementStyle,
                }}>
                <div style={{
                    flexDirection: 'column',
                    display: 'flex',
                    padding: isInline ? 'var(--auth-cookie-padding, 28px)' : 40,
                    backgroundImage: 'url(/cookie.svg)',
                    backgroundRepeat: 'no-repeat',
                    flex: 1,
                    minHeight: isInline ? 'var(--auth-cookie-body-height, 220px)' : undefined,
                    width: '100%',
                    backgroundSize: isInline ? '150px auto' : 'contain',
                    backgroundPosition: isInline ? 'right 18px bottom 8px' : '100% 100px',
                }}>
                    <div style={{ maxWidth: isInline ? 270 : undefined, marginBottom: 12 }}>
                        <Headline4 style={{fontWeight: '600', ...(isInline ? { fontSize: 'var(--auth-cookie-title-size, 26px)', lineHeight: 1.25 } : {})}} translationKey="_COOKIE_USAGE_CAPTION_">Vores hjemmeside anvender cookies</Headline4>
                    </div>
                    <div style={{ maxWidth: isInline ? 280 : undefined, marginBottom: 8 }}>
                        <ContentExtraSmall translationKey="_COOKIE_READ_MORE_TEXT_">Du kan læse mere om hvilke cookies, som siden bruger på Cookiepolitik.</ContentExtraSmall>
                    </div>
                    <div>
                        <ContentExtraSmall>
                            <Link to={'/cookie-policy'} target="_blank">{translate('_COOKIE_POLICY_LINK_', 'Gå til cookiepolitik')}</Link>
                        </ContentExtraSmall>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    flexDirection: isInline ? 'column' : 'row',
                    gap: 10,
                    padding: isInline ? 'var(--auth-cookie-padding, 24px)' : '24px 10px',
                    backgroundColor: isInline ? '#f7f8fa' : '#F0F0F0',
                    borderTop: isInline ? '1px solid #e8ebef' : undefined,
                    justifyContent: 'space-around'
                }}>
                    <ButtonMedium1 showIcon={false} onClick={() => createCookie()} translationKey="_COOKIE_ACCEPT_" >Tillad cookies</ButtonMedium1>
                    <ButtonMedium3 showIcon={false} onClick={() => alert("Vores side kræver cookie tilladelse. Venligst accepter cookies for at benytte siden.")} translationKey="_COOKIE_REJECT_">Afvis cookies</ButtonMedium3>
                </div>
            </Paper>
        </div>
    )
}

export default CookiePopUp;